"use client";

import { useTranslations } from "next-intl";
import Image from 'next/image';
import { useRouter } from "next-nprogress-bar";
import Button from "@apg.gg/core/lib/Button";
import { useParams } from "next/navigation";

export default function ValorantSectionClient() {
  const router = useRouter();
  const { locale } = useParams();
  const t = useTranslations('Home');

  return (
    <section className="w-full py-12 md:py-24 lg:py-32 bg-black-900">
      <div className="container grid items-center gap-6 px-4 md:px-6 lg:grid-cols-2 lg:gap-10">
        <div className="space-y-4">
          <div className="inline-block rounded-2xl bg-blue-400 px-3 py-1 text-sm">Valorant</div>
          <h2 className="text-display-sm">
            {t("sleek-and-efficient-map-selection")}
          </h2>
          <p className="max-w-[600px] font-source-sans-pro text-muted-foreground md:text-ti/relaxed lg:text-base/relaxed xl:text-xl/relaxed">
            {t("enhance-your-valorant-production-with-our-mapveto-tool")}
          </p>
          <div>
            <Button
              type="primary"
              className="text-title-sm"
              onClick={() => {
                router.push(`/${locale}/honor-of-kings`);
              }}
            >
              {t("discover-our-tools")}
            </Button>
          </div>
        </div>
        <div className="flex relative mx-auto">
          <div className="absolute inset-0 w-full h-full flex items-center justify-center">
            <h4 className="text-title-md">Coming soon</h4>
          </div>
          <Image 
            src="/assets/resources/bg-apg-pattern.png" 
            width={600} 
            height={400} 
            className="rounded-xl object-cover"
            alt="Valorant"
          />
        </div>
      </div>
    </section>
  )
}